import React from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import './TimeChart.styles.scss';

import { Line, defaults } from 'react-chartjs-2';

function TimeChart(props) {
    const {
        linesData
    } = props;


    defaults.global.legend.display = false;
    defaults.global.tooltips.intersect = false;
    defaults.global.tooltips.mode = 'nearest';
    // defaults.global.tooltips.enabled = false;

    const data = (canvas) => {
        const ctx = canvas.getContext("2d");

        return {
            labels: ['Morning', 'Midday', 'Afternoon', 'Evening', 'Late night'],
            datasets: linesData.map((lineData, lineIndex) => ({
                borderColor: lineData.color,
                pointBackgroundColor: lineData.color,
                backgroundColor: (() => {
                    const gradient = ctx.createLinearGradient(250, 20, 250, 230);
                    lineData.fillColors.forEach(
                        (color, index) => gradient.addColorStop(index, color)
                    );
                    return gradient;
                })(),
                pointBorderWidth: 0,
                pointRadius: 5,
                pointHoverRadius: 5,
                borderWidth: 1,
                tension: 0,
                data: lineData.data,
                id: lineIndex + 1,
            })),
        }
    };

    const options = {
        responsive: false,
        scales: {
            xAxes: [{
                display: true,
                gridLines: {
                    drawOnChartArea: false,
                    drawTicks: false,
                },
                ticks: {
                    fontColor: '#D5D9E0',
                    fontSize: 14,
                    fontFamily: "'Muli', sans-serif",
                }
            }],
            yAxes: [{
                display: true,
                gridLines: {
                    display: false,
                    zeroLineColor: '#D5D9E0',
                },
                ticks: {
                    fontColor: '#D5D9E0',
                    fontSize: 14,
                    fontFamily: "'Muli', sans-serif",
                    padding: 64,
                    maxTicksLimit: 4,
                    stepSize: 5,
                    callback: function (value, index, values) {
                        return `${value}%`;
                    }
                }
            }],
        },
    };

    return (
        <div className="TimeChart">
            <AutoSizer>
                {({ width, height }) => (
                    <Line
                        key={`${width}:${height}`}
                        id="time-chart"
                        width={width}
                        height={height}
                        options={options}
                        data={data}
                        datasetKeyProvider={({ id }) => id}
                    />
                )}
            </AutoSizer>
        </div>
    );
}

export default TimeChart;
